<template>
  <div class="ad-overall-reject">
    <p class="ad-overall-reject__hint">
      {{ $t('lbl_EMPBE_ProductInfo_OverallReject_Hint') }}
    </p>
    <FieldRejectionFeedback
      ref="fieldRejectionFeedback"
      :value="displayValue"
      mode="admin"
      :rejected="manuallyActive"
      :templates="templates"
      :actor="actor"
      :rejected-count="rejectedCount"
      @input="$emit('input', $event)"
      @update:rejected="onRejectedUpdate"
    />
  </div>
</template>

<script>
import FieldRejectionFeedback from '@/components/FieldRejectionFeedback/FieldRejectionFeedback.vue';
import { adService } from '../../_services';

export default {
  name: 'AdOverallRejectPanel',
  components: { FieldRejectionFeedback },
  props: {
    value: { type: String, default: '' },
    actor: { type: String, default: '' },
    templates: { type: Array, default: () => [] },
    forceActive: { type: Boolean, default: false },
    rejectedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      manuallyActive: false,
    };
  },
  computed: {
    displayValue() {
      return adService.resolveAdRejectReasonText(this.value);
    },
  },
  watch: {
    forceActive: {
      immediate: true,
      handler(val) {
        if (val) this.manuallyActive = true;
      },
    },
    value: {
      immediate: true,
      handler(val) {
        const resolved = adService.resolveAdRejectReasonText(val);
        if (resolved && resolved !== String(val || '').trim()) {
          this.$emit('input', resolved);
        }
      },
    },
  },
  methods: {
    ensureActive() {
      this.manuallyActive = true;
    },
    isRejectActive() {
      return this.manuallyActive === true;
    },
    focusReason() {
      this.$nextTick(() => {
        const frf = this.$refs.fieldRejectionFeedback;
        const el = frf && frf.$refs && frf.$refs.reasonInput;
        if (el && typeof el.focus === 'function') el.focus();
      });
    },
    showReasonError(message, options = {}) {
      const shouldScroll = options.scroll !== false;
      this.$nextTick(() => {
        const frf = this.$refs.fieldRejectionFeedback;
        if (frf && typeof frf.showError === 'function') {
          frf.showError(message, { scroll: shouldScroll });
        } else if (shouldScroll) {
          this.focusReason();
        }
      });
    },
    onRejectedUpdate(rejected) {
      this.manuallyActive = !!rejected;
      if (!rejected) {
        this.$emit('input', '');
      } else {
        this.focusReason();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ad-overall-reject {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0 0 12px;
  padding: 8px;
  border: 1px solid #7366ff;
  border-radius: 16px;
  box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
  box-sizing: border-box;
  background: #fff;
  overflow: visible;
}

.ad-overall-reject__hint {
  margin: 0;
  padding: 4px;
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  color: rgba(0, 0, 0, 0.8);
}
</style>
